import React, {Fragment, useState} from 'react';
import {EuiDescribedFormGroup, EuiFormRow, EuiPanel, EuiSelect} from "@elastic/eui";

type OrderFormActionsProps=
{
    ShowAction : boolean;
    Actions : any[],
    OnChange : (value:any)=>void
}
const OrderFormActionsSelector = ({ShowAction, Actions,OnChange}: OrderFormActionsProps) => {
    const [value, setValue] = useState('SelectOption');
    return (
        <Fragment>
            {
                (ShowAction) ?
                    (<EuiPanel>
                            <EuiDescribedFormGroup title={<h3>Order Actions</h3>}>
                                <EuiFormRow label={'Next action'}>
                                    <EuiSelect options={Actions}
                                               onChange={OnChange}
                                    />
                                </EuiFormRow>
                            </EuiDescribedFormGroup>
                        </EuiPanel>
                    ) : null
            }

        </Fragment>)
}

export default OrderFormActionsSelector;